import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-anperniger',
  templateUrl: './anperniger.component.html',
  styleUrls: ['./anperniger.component.scss']
})
export class AnperNigerComponent {

  constructor() { }

}
